import apiClient from '@/services/axios'

export async function login(user) {
  return apiClient
    .post('/auth/signin', {
      email: user.email,
      password: user.password,
    })
    .then(async (response) => {
      if (response?.data?.success) {
        const { userId, accessToken, needs2FA, loginToken } = response.data
        return {
          success: true,
          userId,
          accessToken,
          needs2FA: !!needs2FA,
          loginToken,
        }
      }
      return { success: false, userId: '' }
    })
    .catch((err) => console.log(err))
}

export async function register(user) {
  return apiClient.post('/auth/signup', {
    firstName: user.firstName,
    lastName: user.lastName,
    email: user.email,
    password: user.password,
    role: Number(user.role),
  })
}

export async function currentAccount() {
  return apiClient
    .get('/users/me')
    .then((response) => {
      if (response) {
        return response.data
      }
      return false
    })
    .catch((err) => console.log(err))
}

export async function verifyEmail(userId) {
  return apiClient
    .post('/auth/verifyEmail', {
      userId: userId,
    })
    .then(() => {
      return { success: true }
    })
    .catch((err) => console.log(err))
}
export async function forgotPassword(email) {
  return apiClient
    .post('/auth/forgotPassword', {
      email: email,
    })
    .then(() => {
      return { success: true }
    })
    .catch((err) => console.log(err))
}

export async function resendCode(data) {
  return apiClient
    .post('/auth/verifyEmail', {
      userId: data.userId,
    })
    .then((response) => {
      if (response.data.success) {
        return { success: true }
      } else {
        return { success: false }
      }
    })
    .catch((err) => console.log(err))
}

export async function verifyToken(token) {
  return apiClient.post('/auth/verifyToken', {
    token,
  })
}
export async function resetPassword(data) {
  return apiClient.post('/auth/resetPassword', data)
}

export async function verifyTotp(data) {
  // The login token from /auth/signin proves the password step was done; a
  // user id alone let anyone with a guessed code in. A backend that issues no
  // token yet still takes the id.
  const body = data.loginToken
    ? { loginToken: data.loginToken, code: data.code, trustDevice: data.trustDevice }
    : { userId: data.userId, code: data.code, trustDevice: data.trustDevice }
  return apiClient
    .post('/auth/verifyTotp', body)
    .then((response) => {
      if (response?.data?.success) {
        const { accessToken } = response.data
        return { success: true, accessToken }
      }
      return { success: false }
    })
    .catch((err) => {
      console.log(err)
      return { success: false }
    })
}

export async function verifyEmailCode(data) {
  return apiClient
    .post('/auth/verifyEmailCode', {
      userId: data.userId,
      code: data.code,
      trustDevice: data.trustDevice,
    })
    .then((response) => {
      if (response?.data?.success) {
        const { accessToken } = response.data
        return { success: true, accessToken: accessToken }
      }
      return { success: false, accessToken: '' }
    })
    .catch((err) => console.log(err))
}

export async function logout() {
  return apiClient
    .post('/auth/signout')
    .then(() => {
      localStorage.removeItem('accessToken')
      return true
    })
    .catch((err) => console.log(err))
}
